(() => {
  if (window.__lazyLoadFadeInit) return;
  window.__lazyLoadFadeInit = true;

  function bind(img) {
    if (img.__lazyFadeBound) return;
    img.__lazyFadeBound = true;
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add('loaded');
      return;
    }
    const mark = () => img.classList.add('loaded');
    img.addEventListener('load', mark, { once: true });
    img.addEventListener('error', mark, { once: true });
  }

  function scan(root) {
    (root || document).querySelectorAll('img[loading="lazy"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('img[loading="lazy"]')) bind(node);
        else scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
